import { Typography, Button } from '@ui/components';
import { HasPermission } from '@shared/components';
import { useTranslation } from 'react-i18next';
import { Plus } from '@ui/components/icons';

import { EmployeesMassImportDialog } from '../../employees-mass-import-dialog/employees-mass-import-dialog';

interface EmployeesHeaderProps {
  onAddEmployee: () => void;
}

export const EmployeesHeader = (props: EmployeesHeaderProps) => {
  const { onAddEmployee } = props;
  const { t } = useTranslation();

  return (
    <div className="flex justify-between items-center mb-4">
      <Typography variant="h300" element="h1">
        {t('EMPLOYEES.TITLE')}
      </Typography>

      <div className="flex gap-4">
        <HasPermission permissionFeature="EMPLOYEES_ADD_EMPLOYEE" permissionType="WRITE">
          <Button onClick={onAddEmployee}>
            <Plus className="w-4 h-4" />
            {t('EMPLOYEES.ADD_EMPLOYEE')}
          </Button>
        </HasPermission>

        <HasPermission permissionFeature="EMPLOYEES_IMPORT_EMPLOYEES" permissionType="WRITE">
          <EmployeesMassImportDialog>
            <Button variant="secondary">{t('EMPLOYEES.IMPORT_EMPLOYEES')}</Button>
          </EmployeesMassImportDialog>
        </HasPermission>
      </div>
    </div>
  );
};
